export default __webpack_public_path__ + "static/media/colusa-riverside-inn.633d36cc.webp";